<footer>
    <a class="link"
      [routerLink]="['/legalAndPrivacy']"
      [queryParams]="{ view: 'privacy-policy', from: context }">Privacy Policy</a>
    <a class="link"
      [routerLink]="['/legalAndPrivacy']"
      [queryParams]="{ view: 'legal-notice', from: context }">Legal notice</a>
</footer>


